import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { resetAppState, setOverlay } from '../../../redux/slices/appStateSlice';
import { Image, isEditorActive, Text } from '@sitecore-jss/sitecore-jss-react';
import { OverlayConstants } from '../../../Constants';
import { resetQuoteData } from '../../../redux/slices/quoteDataSlice';
import { resetQuoteResponse } from '../../../redux/slices/quoteResponseSlice';
import { resetAddressResults } from '../../../redux/slices/addressResultsSlice';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';
import { useLocation } from 'react-router-dom';
import config from '../../../temp/config';

const GlobalNavigation = ({ prevPage, fields }) => {
  const dispatch = useDispatch();
  const navigate = useInternalNavigate();
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);

  const showCallback = () => {
    dispatch(setOverlay({ type: OverlayConstants.Callback }));
  };

  const normalizePath = path => {
    if (!path) {
      return '';
    }
    return String(path).split('?')[0].replace(/\/+$/, '').toLowerCase();
  };

  const current = normalizePath(location.pathname);
  const first = normalizePath(config?.urls?.firstPage);
  const success = normalizePath(config?.urls?.successPage);
  const servicedown = normalizePath(config?.urls?.serviceDown);
  const prevPageNavigate = () => {
    if (normalizePath(prevPathRef.current).includes(servicedown) || current.endsWith(servicedown)) {
      navigate(first);
      resetApp();
      if (typeof window !== 'undefined') {
        window.location.assign(first);
      }
      return;
    }
    navigate(prevPage);
  };

  const showBackButton =
    hydrated && current && !current.includes(first) && !current.includes(success);

  const backButtonDisplay = showBackButton ? 'block' : 'none';

  const resetApp = () => {
    dispatch(resetAppState());
    dispatch(resetQuoteData());
    dispatch(resetQuoteResponse());
    dispatch(resetAddressResults());
  };

  useEffect(() => {
    const wasOnSuccessPage = normalizePath(prevPathRef.current).includes(success);
    const isNowOffSuccessPage = !current.includes(success);

    if (wasOnSuccessPage && isNowOffSuccessPage) {
      navigate(first);
      resetApp();
    }

    prevPathRef.current = location.pathname;
  }, [location.pathname, success, first, current]);

  return (
    <nav
      className={
        'vds-global-navigation vds-global-navigation--form-journey vds-global-navigation--update-2022 ' +
        (isEditorActive() ? 'paddingTopNone' : '')
      }
      aria-label="Primary navigation"
    >
      <div className={'vds-global-navigation__inner ' + (isEditorActive() ? 'positionUnset' : '')}>
        <div className="vds-global-navigation__primary" style={{ display: backButtonDisplay }}>
          <button
            className="vds-global-navigation__back-button"
            onClick={prevPageNavigate}
            data-testid={`${fields.testid?.value}-back`}
          >
            <Text
              tag="span"
              className="vds-global-navigation__back-text"
              field={fields.backButtonText}
            />
          </button>
        </div>

        <div className="vds-global-navigation__secondary">
          <div className="vds-global-navigation__logo-link">
            <Image
              className="vds-global-navigation__logo"
              editable={false}
              field={fields.logo}
              alt="Vitality Logo"
              data-testid={`${fields.testid?.value}-logo`}
              onClick={() => {
                window.location.href = fields.homeUrl?.value;
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
        {fields.callbackButtonText && (
          <div className="vds-global-navigation__tertiary">
            <div className="vds-global-navigation__help">
              <button
                onClick={showCallback}
                type="button"
                className="vds-global-navigation__callback-button"
                data-testid={`${fields.testid?.value}-callback-button`}
              >
                <Text
                  tag="span"
                  className="vds-global-navigation__callback-text"
                  field={fields.callbackButtonText}
                />
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

const mapStateToProps = (state, oldProps) => {
  return {
    ...oldProps,
    prevPage: state.appState?.prevPage ?? oldProps?.prevPage,
  };
};
export default connect(mapStateToProps)(GlobalNavigation);
